import { COUNTRIES } from '@config/constants'

export const COUNTRIES_WITH_REVIEWS_LEGAL_MODAL = [COUNTRIES.FR]
